var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldRender
    ? _c(
        "div",
        {
          class: [
            "article-pagination",
            _vm.shouldRender && _vm.loading && "loading",
          ],
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "fa fa-spinner fa-spin fa-4x" })
            : [
                _vm.paginationInfo
                  ? _c("div", { staticClass: "pagination-container" }, [
                      _c("label", [_vm._v("Pages")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pagination-wrapper" },
                        [
                          _c(
                            "Pagination",
                            _vm._b(
                              {
                                attrs: { editable: false, showOffsets: false },
                                on: { change: _vm.handlePageNavigation },
                              },
                              "Pagination",
                              _vm.paginationInfo,
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hitInfo && _vm.paginationInfo != null ? _c("hr") : _vm._e(),
                _vm._v(" "),
                _vm.hitInfo
                  ? _c("div", { staticClass: "pagination-container" }, [
                      _c("label", [_vm._v("Hits")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pagination-wrapper" },
                        [
                          _c(
                            "Pagination",
                            _vm._b(
                              {
                                attrs: { editable: false, showOffsets: false },
                                on: { change: _vm.handleHitNavigation },
                              },
                              "Pagination",
                              _vm.hitInfo,
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }